export default {
    
    find:   { method: 'get',    url: 'budget_types' },
    create: { method: 'post',   url: 'budget_types'},
    update: { method: 'put',    url: 'budget_types/{id}'},
    delete: { method: 'delete', url: 'budget_types/{id}'}
}